var map = {
	"./arrows/default": 50,
	"./arrows/default.svg": 50,
	"./arrows/down": 51,
	"./arrows/down-short": 52,
	"./arrows/down-short.svg": 52,
	"./arrows/down.svg": 51,
	"./arrows/long": 53,
	"./arrows/long-white": 54,
	"./arrows/long-white.svg": 54,
	"./arrows/long.svg": 53,
	"./arrows/right": 55,
	"./arrows/right.svg": 55,
	"./arrows/tail-spin": 56,
	"./arrows/tail-spin.svg": 56,
	"./bg/flag": 57,
	"./bg/flag.png": 57,
	"./bg/group-course": 58,
	"./bg/group-course-wave": 59,
	"./bg/group-course-wave-pink": 60,
	"./bg/group-course-wave-pink.svg": 60,
	"./bg/group-course-wave.svg": 59,
	"./bg/group-course.svg": 58,
	"./bg/headers/bamboo-forest-left": 61,
	"./bg/headers/bamboo-forest-left.png": 61,
	"./bg/headers/bamboo-forest-right": 62,
	"./bg/headers/bamboo-forest-right.png": 62,
	"./bg/headers/course": 63,
	"./bg/headers/course.jpg": 63,
	"./bg/headers/geta": 64,
	"./bg/headers/geta.png": 64,
	"./bg/headers/gold-fish": 65,
	"./bg/headers/gold-fish.png": 65,
	"./bg/headers/meal": 66,
	"./bg/headers/meal.png": 66,
	"./bg/headers/origami": 67,
	"./bg/headers/origami.png": 67,
	"./bg/headers/pricing": 68,
	"./bg/headers/pricing.png": 68,
	"./bg/headers/registration": 69,
	"./bg/headers/registration.jpg": 69,
	"./bg/headers/sumo": 70,
	"./bg/headers/sumo.png": 70,
	"./bg/headers/test": 71,
	"./bg/headers/test.jpg": 71,
	"./bg/headers/testimonials": 72,
	"./bg/headers/testimonials.svg": 72,
	"./bg/headers/video-course": 73,
	"./bg/headers/video-course.svg": 73,
	"./bg/hero": 1,
	"./bg/hero.jpg": 317,
	"./bg/hero.svg": 1,
	"./bg/mosaic": 74,
	"./bg/mosaic.png": 74,
	"./bg/mosaic/ab1": 75,
	"./bg/mosaic/ab1.jpg": 75,
	"./bg/mosaic/ab2": 76,
	"./bg/mosaic/ab2.jpg": 76,
	"./bg/mosaic/brushes": 77,
	"./bg/mosaic/brushes.svg": 77,
	"./bg/mosaic/calligraphy": 78,
	"./bg/mosaic/calligraphy.jpg": 78,
	"./bg/mosaic/camp": 79,
	"./bg/mosaic/camp-2": 80,
	"./bg/mosaic/camp-2.jpg": 80,
	"./bg/mosaic/camp.jpg": 79,
	"./bg/mosaic/circle": 81,
	"./bg/mosaic/circle.svg": 81,
	"./bg/mosaic/cloud": 82,
	"./bg/mosaic/cloud-lightblue": 83,
	"./bg/mosaic/cloud-lightblue.svg": 83,
	"./bg/mosaic/cloud-red": 84,
	"./bg/mosaic/cloud-red.svg": 84,
	"./bg/mosaic/cloud.svg": 82,
	"./bg/mosaic/concert": 85,
	"./bg/mosaic/concert.jpg": 85,
	"./bg/mosaic/conversation": 86,
	"./bg/mosaic/conversation.svg": 86,
	"./bg/mosaic/dinner": 87,
	"./bg/mosaic/dinner.jpg": 87,
	"./bg/mosaic/doki-doki": 88,
	"./bg/mosaic/doki-doki.jpg": 88,
	"./bg/mosaic/drum": 89,
	"./bg/mosaic/drum.jpg": 89,
	"./bg/mosaic/hanami": 90,
	"./bg/mosaic/hanami.jpg": 90,
	"./bg/mosaic/hidden-message": 91,
	"./bg/mosaic/hidden-message.svg": 91,
	"./bg/mosaic/kimono": 92,
	"./bg/mosaic/kimono.svg": 92,
	"./bg/mosaic/koi": 93,
	"./bg/mosaic/koi.svg": 93,
	"./bg/mosaic/lector": 94,
	"./bg/mosaic/lector.jpg": 94,
	"./bg/mosaic/lesson": 95,
	"./bg/mosaic/lesson.jpg": 95,
	"./bg/mosaic/monika": 96,
	"./bg/mosaic/monika.jpg": 96,
	"./bg/mosaic/monitor": 97,
	"./bg/mosaic/monitor.svg": 97,
	"./bg/mosaic/ninja": 98,
	"./bg/mosaic/ninja.jpg": 98,
	"./bg/mosaic/origami": 99,
	"./bg/mosaic/origami-lightblue": 100,
	"./bg/mosaic/origami-lightblue.svg": 100,
	"./bg/mosaic/origami.svg": 99,
	"./bg/mosaic/oyakata": 101,
	"./bg/mosaic/oyakata.svg": 101,
	"./bg/mosaic/pattern-arrows": 102,
	"./bg/mosaic/pattern-arrows-light-blue": 103,
	"./bg/mosaic/pattern-arrows-light-blue.svg": 103,
	"./bg/mosaic/pattern-arrows-red": 104,
	"./bg/mosaic/pattern-arrows-red.svg": 104,
	"./bg/mosaic/pattern-arrows.svg": 102,
	"./bg/mosaic/pattern-circles": 105,
	"./bg/mosaic/pattern-circles-bigger": 106,
	"./bg/mosaic/pattern-circles-bigger.svg": 106,
	"./bg/mosaic/pattern-circles.svg": 105,
	"./bg/mosaic/pattern-daisy": 107,
	"./bg/mosaic/pattern-daisy-pink": 108,
	"./bg/mosaic/pattern-daisy-pink.svg": 108,
	"./bg/mosaic/pattern-daisy.svg": 107,
	"./bg/mosaic/pattern-flowers": 109,
	"./bg/mosaic/pattern-flowers.svg": 109,
	"./bg/mosaic/pattern-hexagon": 110,
	"./bg/mosaic/pattern-hexagon.svg": 110,
	"./bg/mosaic/pattern-hills": 111,
	"./bg/mosaic/pattern-hills.svg": 111,
	"./bg/mosaic/pattern-husk": 112,
	"./bg/mosaic/pattern-husk-blue": 113,
	"./bg/mosaic/pattern-husk-blue.svg": 113,
	"./bg/mosaic/pattern-husk-saphire": 114,
	"./bg/mosaic/pattern-husk-saphire.svg": 114,
	"./bg/mosaic/pattern-husk.svg": 112,
	"./bg/mosaic/pattern-triangles": 115,
	"./bg/mosaic/pattern-triangles-red": 116,
	"./bg/mosaic/pattern-triangles-red.svg": 116,
	"./bg/mosaic/pattern-triangles.svg": 115,
	"./bg/mosaic/pattern-wave": 117,
	"./bg/mosaic/pattern-wave.svg": 117,
	"./bg/mosaic/pattern-zigzag": 118,
	"./bg/mosaic/pattern-zigzag-light-blue": 119,
	"./bg/mosaic/pattern-zigzag-light-blue.svg": 119,
	"./bg/mosaic/pattern-zigzag.svg": 118,
	"./bg/mosaic/performance": 120,
	"./bg/mosaic/performance.jpg": 120,
	"./bg/mosaic/sakura": 121,
	"./bg/mosaic/sakura.svg": 121,
	"./bg/mosaic/sencha": 122,
	"./bg/mosaic/sencha.jpg": 122,
	"./bg/mosaic/shodo": 123,
	"./bg/mosaic/shodo-lesson": 124,
	"./bg/mosaic/shodo-lesson.jpg": 124,
	"./bg/mosaic/shodo.jpg": 123,
	"./bg/mosaic/sun": 125,
	"./bg/mosaic/sun.svg": 125,
	"./bg/mosaic/team": 126,
	"./bg/mosaic/team.jpg": 126,
	"./bg/mosaic/temple": 127,
	"./bg/mosaic/temple.svg": 127,
	"./bg/mosaic/workshops": 128,
	"./bg/mosaic/workshops.jpg": 128,
	"./bg/pattern": 129,
	"./bg/pattern.svg": 129,
	"./bg/patterns/activities/1": 130,
	"./bg/patterns/activities/1.svg": 130,
	"./bg/patterns/activities/2": 131,
	"./bg/patterns/activities/2.svg": 131,
	"./bg/patterns/activities/3": 132,
	"./bg/patterns/activities/3.svg": 132,
	"./bg/patterns/activities/4": 133,
	"./bg/patterns/activities/4.svg": 133,
	"./bg/patterns/activities/5": 134,
	"./bg/patterns/activities/5.svg": 134,
	"./bg/patterns/blog": 135,
	"./bg/patterns/blog.svg": 135,
	"./bg/patterns/chessboard": 136,
	"./bg/patterns/chessboard.svg": 136,
	"./bg/patterns/clouds": 137,
	"./bg/patterns/clouds.svg": 137,
	"./bg/patterns/ellipse": 138,
	"./bg/patterns/ellipse.svg": 138,
	"./bg/patterns/husk": 139,
	"./bg/patterns/husk.svg": 139,
	"./bg/patterns/materials": 140,
	"./bg/patterns/materials.svg": 140,
	"./bg/patterns/mosaic": 141,
	"./bg/patterns/mosaic.svg": 141,
	"./bg/patterns/pixels": 142,
	"./bg/patterns/pixels.svg": 142,
	"./bg/patterns/shape-blue": 143,
	"./bg/patterns/shape-blue.svg": 143,
	"./bg/patterns/squares": 144,
	"./bg/patterns/squares.svg": 144,
	"./bg/patterns/triangles": 145,
	"./bg/patterns/triangles-light": 146,
	"./bg/patterns/triangles-light.svg": 146,
	"./bg/patterns/triangles.svg": 145,
	"./bg/shapes/circle": 147,
	"./bg/shapes/circle.svg": 147,
	"./bg/shapes/cloud-1": 148,
	"./bg/shapes/cloud-1.svg": 148,
	"./bg/shapes/cloud-2": 149,
	"./bg/shapes/cloud-2.svg": 149,
	"./bg/shapes/cloud-blue": 150,
	"./bg/shapes/cloud-blue.svg": 150,
	"./bg/shapes/cloud-lightblue": 151,
	"./bg/shapes/cloud-lightblue.svg": 151,
	"./bg/shapes/cloud-red": 152,
	"./bg/shapes/cloud-red.svg": 152,
	"./bg/shapes/cube": 153,
	"./bg/shapes/cube.svg": 153,
	"./bg/shapes/ecru/1": 154,
	"./bg/shapes/ecru/1.svg": 154,
	"./bg/shapes/ecru/2": 155,
	"./bg/shapes/ecru/2.svg": 155,
	"./bg/shapes/ecru/3": 156,
	"./bg/shapes/ecru/3.svg": 156,
	"./bg/shapes/ecru/4": 157,
	"./bg/shapes/ecru/4.svg": 157,
	"./bg/shapes/gallery/activities": 158,
	"./bg/shapes/gallery/activities.svg": 158,
	"./bg/shapes/gallery/party": 159,
	"./bg/shapes/gallery/party.svg": 159,
	"./bg/shapes/gallery/trips": 160,
	"./bg/shapes/gallery/trips.svg": 160,
	"./bg/shapes/husk": 161,
	"./bg/shapes/husk.svg": 161,
	"./bg/shapes/triangles": 162,
	"./bg/shapes/triangles.svg": 162,
	"./icons/check": 163,
	"./icons/check-green": 164,
	"./icons/check-green.svg": 164,
	"./icons/check-light": 165,
	"./icons/check-light.svg": 165,
	"./icons/check-white": 166,
	"./icons/check-white.svg": 166,
	"./icons/check.svg": 163,
	"./icons/close": 167,
	"./icons/close.svg": 167,
	"./icons/cookies": 168,
	"./icons/cookies.svg": 168,
	"./icons/cross": 169,
	"./icons/cross.svg": 169,
	"./icons/dot": 170,
	"./icons/dot.svg": 170,
	"./icons/enroll": 171,
	"./icons/enroll.svg": 171,
	"./icons/envelope": 172,
	"./icons/envelope.svg": 172,
	"./icons/facebook": 173,
	"./icons/facebook-w": 174,
	"./icons/facebook-w.svg": 174,
	"./icons/facebook.svg": 173,
	"./icons/fb": 175,
	"./icons/fb.svg": 175,
	"./icons/flag-en": 176,
	"./icons/flag-en.svg": 176,
	"./icons/flag-jp": 177,
	"./icons/flag-jp.svg": 177,
	"./icons/flag-pl": 178,
	"./icons/flag-pl.svg": 178,
	"./icons/gift": 179,
	"./icons/gift.svg": 179,
	"./icons/instagram": 180,
	"./icons/instagram-w": 181,
	"./icons/instagram-w.svg": 181,
	"./icons/instagram.svg": 180,
	"./icons/keyboard": 182,
	"./icons/keyboard.svg": 182,
	"./icons/linkedin": 183,
	"./icons/linkedin.svg": 183,
	"./icons/marker": 2,
	"./icons/marker.png": 2,
	"./icons/marker.svg": 318,
	"./icons/mobile": 184,
	"./icons/mobile.svg": 184,
	"./icons/price": 185,
	"./icons/price-blue": 186,
	"./icons/price-blue.svg": 186,
	"./icons/price-green": 187,
	"./icons/price-green.svg": 187,
	"./icons/price-pink": 188,
	"./icons/price-pink.svg": 188,
	"./icons/price.svg": 185,
	"./icons/quote": 189,
	"./icons/quote-big": 190,
	"./icons/quote-big.svg": 190,
	"./icons/quote.svg": 189,
	"./icons/star-1-blue": 191,
	"./icons/star-1-blue.svg": 191,
	"./icons/star-1-red": 192,
	"./icons/star-1-red.svg": 192,
	"./icons/star-3-blue": 193,
	"./icons/star-3-blue.svg": 193,
	"./icons/star-3-red": 194,
	"./icons/star-3-red.svg": 194,
	"./icons/tag-blue": 195,
	"./icons/tag-blue.svg": 195,
	"./icons/tag-red": 196,
	"./icons/tag-red.svg": 196,
	"./icons/twitter": 197,
	"./icons/twitter.svg": 197,
	"./icons/youtube": 198,
	"./icons/youtube.svg": 198,
	"./icons/zoom": 199,
	"./icons/zoom.svg": 199,
	"./logo": 200,
	"./logo-mobile": 201,
	"./logo-mobile.svg": 201,
	"./logo.svg": 200,
	"./media/images/pic/teachers/anna-sielawko": 3,
	"./media/images/pic/teachers/anna-sielawko.png": 3,
	"./media/images/pic/teachers/anna-sielawko.webp": 319,
	"./media/images/pic/teachers/joanna-shimada": 4,
	"./media/images/pic/teachers/joanna-shimada.png": 4,
	"./media/images/pic/teachers/joanna-shimada.webp": 320,
	"./media/images/pic/teachers/kaede-funakoshi": 5,
	"./media/images/pic/teachers/kaede-funakoshi.png": 5,
	"./media/images/pic/teachers/kaede-funakoshi.webp": 321,
	"./media/images/pic/teachers/krzysztof-walaszek": 6,
	"./media/images/pic/teachers/krzysztof-walaszek.png": 6,
	"./media/images/pic/teachers/krzysztof-walaszek.webp": 322,
	"./media/images/pic/teachers/magdalena-kisly": 7,
	"./media/images/pic/teachers/magdalena-kisly.png": 7,
	"./media/images/pic/teachers/magdalena-kisly.webp": 323,
	"./media/images/pic/teachers/wiktoria-piontek": 8,
	"./media/images/pic/teachers/wiktoria-piontek.png": 8,
	"./media/images/pic/teachers/wiktoria-piontek.webp": 324,
	"./pic/activities/sakaki": 202,
	"./pic/activities/sakaki.png": 202,
	"./pic/activities/shizuoka": 203,
	"./pic/activities/shizuoka.png": 203,
	"./pic/activities/tokio": 204,
	"./pic/activities/tokio.png": 204,
	"./pic/advantage": 205,
	"./pic/advantage-mobile": 206,
	"./pic/advantage-mobile.png": 206,
	"./pic/advantage.png": 205,
	"./pic/authors/agata-krukowska": 207,
	"./pic/authors/agata-krukowska.png": 207,
	"./pic/authors/marta-klimiuk": 208,
	"./pic/authors/marta-klimiuk.png": 208,
	"./pic/authors/monika-zachaj": 209,
	"./pic/authors/monika-zachaj.png": 209,
	"./pic/blank/226x183": 210,
	"./pic/blank/226x183.jpg": 210,
	"./pic/bunkasai": 211,
	"./pic/bunkasai.jpg": 211,
	"./pic/compare/after": 212,
	"./pic/compare/after.jpg": 212,
	"./pic/compare/before": 213,
	"./pic/compare/before.jpg": 213,
	"./pic/compare/old/after": 214,
	"./pic/compare/old/after.jpg": 214,
	"./pic/compare/old/before": 215,
	"./pic/compare/old/before.jpg": 215,
	"./pic/contact": 216,
	"./pic/contact.svg": 216,
	"./pic/courses/00": 217,
	"./pic/courses/00.svg": 217,
	"./pic/courses/01": 218,
	"./pic/courses/01.svg": 218,
	"./pic/courses/02": 219,
	"./pic/courses/02.svg": 219,
	"./pic/courses/advanced-level": 220,
	"./pic/courses/advanced-level.png": 220,
	"./pic/courses/beginner-level": 221,
	"./pic/courses/beginner-level.png": 221,
	"./pic/courses/benefit01": 222,
	"./pic/courses/benefit01.svg": 222,
	"./pic/courses/benefit02": 223,
	"./pic/courses/benefit02.svg": 223,
	"./pic/courses/benefit03": 224,
	"./pic/courses/benefit03.svg": 224,
	"./pic/courses/benefit04": 225,
	"./pic/courses/benefit04.svg": 225,
	"./pic/courses/benefit05": 226,
	"./pic/courses/benefit05.svg": 226,
	"./pic/courses/benefit06": 227,
	"./pic/courses/benefit06.svg": 227,
	"./pic/courses/benefit07": 228,
	"./pic/courses/benefit07.svg": 228,
	"./pic/courses/benefit08": 229,
	"./pic/courses/benefit08.svg": 229,
	"./pic/courses/intermediate-level": 230,
	"./pic/courses/intermediate-level.png": 230,
	"./pic/courses/monika-zachaj": 231,
	"./pic/courses/monika-zachaj.png": 231,
	"./pic/courses/pakiet-startowy": 232,
	"./pic/courses/pakiet-startowy.png": 232,
	"./pic/courses/ryotaro-sakamoto": 233,
	"./pic/courses/ryotaro-sakamoto.png": 233,
	"./pic/gallery/2017/japan-bowl-turniej-o-puchar-japonii": 234,
	"./pic/gallery/2017/japan-bowl-turniej-o-puchar-japonii.jpg": 234,
	"./pic/gallery/2017/matsuri-piknik-z-kultura-japonii": 235,
	"./pic/gallery/2017/matsuri-piknik-z-kultura-japonii.jpg": 235,
	"./pic/gallery/2018/japan-bowl-turniej-o-puchar-japonii": 236,
	"./pic/gallery/2018/japan-bowl-turniej-o-puchar-japonii.jpg": 236,
	"./pic/gallery/2018/szkola-letnia": 237,
	"./pic/gallery/2018/szkola-letnia.jpg": 237,
	"./pic/gallery/2018/warsztaty-chust-furoshiki": 238,
	"./pic/gallery/2018/warsztaty-chust-furoshiki.jpg": 238,
	"./pic/gallery/2018/warsztaty-ehomaki": 239,
	"./pic/gallery/2018/warsztaty-ehomaki.jpg": 239,
	"./pic/gallery/2018/warsztaty-herbaty-sencha": 240,
	"./pic/gallery/2018/warsztaty-herbaty-sencha.jpg": 240,
	"./pic/gallery/2018/warsztaty-kawaii-sushi": 241,
	"./pic/gallery/2018/warsztaty-kawaii-sushi.jpg": 241,
	"./pic/gallery/2019/impreza-bonenkai": 242,
	"./pic/gallery/2019/impreza-bonenkai.jpg": 242,
	"./pic/gallery/2019/matsuri-piknik-z-kultura-japonii": 243,
	"./pic/gallery/2019/matsuri-piknik-z-kultura-japonii.jpg": 243,
	"./pic/gallery/2019/szkola-letnia": 244,
	"./pic/gallery/2019/szkola-letnia.jpg": 244,
	"./pic/gallery/2019/warsztaty-obento": 245,
	"./pic/gallery/2019/warsztaty-obento.jpg": 245,
	"./pic/gallery/2019/warsztaty-slodyczy-wagashi": 246,
	"./pic/gallery/2019/warsztaty-slodyczy-wagashi.jpg": 246,
	"./pic/gallery/2020/ceremonia-herbaty": 247,
	"./pic/gallery/2020/ceremonia-herbaty.jpg": 247,
	"./pic/godzilla": 0,
	"./pic/godzilla-mobile": 9,
	"./pic/godzilla-mobile.png": 9,
	"./pic/godzilla-mobile.webp": 325,
	"./pic/godzilla.png": 0,
	"./pic/godzilla.svg": 326,
	"./pic/godzilla.webp": 327,
	"./pic/godzilla/beast": 248,
	"./pic/godzilla/beast.png": 248,
	"./pic/godzilla/pattern": 249,
	"./pic/godzilla/pattern.svg": 249,
	"./pic/google-rating": 250,
	"./pic/google-rating.svg": 250,
	"./pic/hero/all": 251,
	"./pic/hero/all.png": 251,
	"./pic/hero/clouds": 10,
	"./pic/hero/clouds.png": 10,
	"./pic/hero/clouds.webp": 328,
	"./pic/hero/desc": 252,
	"./pic/hero/desc.svg": 252,
	"./pic/hero/land": 11,
	"./pic/hero/land.png": 11,
	"./pic/hero/land.webp": 329,
	"./pic/hero/mobile": 12,
	"./pic/hero/mobile.jpg": 12,
	"./pic/hero/mobile.webp": 330,
	"./pic/hero/mountain": 13,
	"./pic/hero/mountain.png": 13,
	"./pic/hero/mountain.webp": 331,
	"./pic/hero/sea": 14,
	"./pic/hero/sea.png": 14,
	"./pic/hero/sea.webp": 332,
	"./pic/hero/sun": 15,
	"./pic/hero/sun.png": 15,
	"./pic/hero/sun.webp": 333,
	"./pic/hero/trees": 16,
	"./pic/hero/trees.png": 16,
	"./pic/hero/trees.webp": 334,
	"./pic/hero/video-bottom": 253,
	"./pic/hero/video-bottom.svg": 253,
	"./pic/hero/video-top": 254,
	"./pic/hero/video-top.svg": 254,
	"./pic/hero/waves": 17,
	"./pic/hero/waves.png": 17,
	"./pic/hero/waves.webp": 335,
	"./pic/home/1": 255,
	"./pic/home/1.svg": 255,
	"./pic/home/all": 256,
	"./pic/home/all.png": 256,
	"./pic/home/owners": 18,
	"./pic/home/owners.png": 18,
	"./pic/home/owners.svg": 336,
	"./pic/keyboard": 257,
	"./pic/keyboard.svg": 257,
	"./pic/kitty-group": 258,
	"./pic/kitty-group-light": 259,
	"./pic/kitty-group-light.png": 259,
	"./pic/kitty-group.png": 258,
	"./pic/kitty-individual": 260,
	"./pic/kitty-individual.png": 260,
	"./pic/labels/a1_1": 261,
	"./pic/labels/a1_1.png": 261,
	"./pic/labels/a1_1b": 262,
	"./pic/labels/a1_1b.png": 262,
	"./pic/labels/a1_2": 263,
	"./pic/labels/a1_2.png": 263,
	"./pic/labels/a1_2a": 264,
	"./pic/labels/a1_2a.png": 264,
	"./pic/labels/a2_1": 265,
	"./pic/labels/a2_1.png": 265,
	"./pic/labels/a2_1b": 266,
	"./pic/labels/a2_1b.png": 266,
	"./pic/labels/a2_2": 267,
	"./pic/labels/a2_2.png": 267,
	"./pic/labels/a2_2a": 268,
	"./pic/labels/a2_2a.png": 268,
	"./pic/labels/a2_2b": 269,
	"./pic/labels/a2_2b.png": 269,
	"./pic/labels/b1_1": 270,
	"./pic/labels/b1_1.png": 270,
	"./pic/labels/b1_1b": 271,
	"./pic/labels/b1_1b.png": 271,
	"./pic/labels/b1_2": 272,
	"./pic/labels/b1_2.png": 272,
	"./pic/labels/b2_1": 273,
	"./pic/labels/b2_1.png": 273,
	"./pic/labels/b2_2": 274,
	"./pic/labels/b2_2.png": 274,
	"./pic/labels/c1_1": 275,
	"./pic/labels/c1_1.png": 275,
	"./pic/labels/c1_2": 276,
	"./pic/labels/c1_2.png": 276,
	"./pic/labels/c2_2": 277,
	"./pic/labels/c2_2.png": 277,
	"./pic/labels/materials/doki-doki-1": 278,
	"./pic/labels/materials/doki-doki-1.jpg": 278,
	"./pic/labels/materials/doki-doki-2": 279,
	"./pic/labels/materials/doki-doki-2.jpg": 279,
	"./pic/labels/materials/doki-doki-3": 280,
	"./pic/labels/materials/doki-doki-3.jpg": 280,
	"./pic/labels/materials/pera-pera-1": 281,
	"./pic/labels/materials/pera-pera-1.jpg": 281,
	"./pic/labels/materials/pera-pera-2": 282,
	"./pic/labels/materials/pera-pera-2.jpg": 282,
	"./pic/labels/materials/pera-pera-3": 283,
	"./pic/labels/materials/pera-pera-3.jpg": 283,
	"./pic/labels/materials/waku-waku-1": 284,
	"./pic/labels/materials/waku-waku-1.jpg": 284,
	"./pic/labels/materials/waku-waku-2": 285,
	"./pic/labels/materials/waku-waku-2.jpg": 285,
	"./pic/labels/materials/waku-waku-3": 286,
	"./pic/labels/materials/waku-waku-3.jpg": 286,
	"./pic/magazine": 287,
	"./pic/magazine.png": 287,
	"./pic/materials/100-lecie-przyjazni": 288,
	"./pic/materials/100-lecie-przyjazni.png": 288,
	"./pic/materials/hiragana": 289,
	"./pic/materials/hiragana.png": 289,
	"./pic/materials/katakana": 290,
	"./pic/materials/katakana.png": 290,
	"./pic/news-main": 291,
	"./pic/news-main.jpg": 291,
	"./pic/newsletter": 19,
	"./pic/newsletter.png": 19,
	"./pic/newsletter.svg": 337,
	"./pic/owners": 20,
	"./pic/owners.png": 20,
	"./pic/owners.webp": 338,
	"./pic/ramen1": 21,
	"./pic/ramen1.png": 21,
	"./pic/ramen1.svg": 339,
	"./pic/teachers/agata-krukowska": 22,
	"./pic/teachers/agata-krukowska.png": 22,
	"./pic/teachers/agata-krukowska.webp": 340,
	"./pic/teachers/alicja-suska": 23,
	"./pic/teachers/alicja-suska.png": 23,
	"./pic/teachers/alicja-suska.webp": 341,
	"./pic/teachers/animation": 292,
	"./pic/teachers/animation-image": 293,
	"./pic/teachers/animation-image.jpg": 293,
	"./pic/teachers/animation.svg": 292,
	"./pic/teachers/anna-sielawko": 24,
	"./pic/teachers/anna-sielawko.png": 24,
	"./pic/teachers/anna-sielawko.webp": 342,
	"./pic/teachers/hiroko-fujii": 25,
	"./pic/teachers/hiroko-fujii.png": 25,
	"./pic/teachers/hiroko-fujii.webp": 343,
	"./pic/teachers/joanna-shimada": 26,
	"./pic/teachers/joanna-shimada.png": 26,
	"./pic/teachers/joanna-shimada.webp": 344,
	"./pic/teachers/julia-caba": 27,
	"./pic/teachers/julia-caba.png": 27,
	"./pic/teachers/julia-caba.webp": 345,
	"./pic/teachers/kaede-funakoshi": 28,
	"./pic/teachers/kaede-funakoshi.png": 28,
	"./pic/teachers/kaede-funakoshi.webp": 346,
	"./pic/teachers/katarzyna-stanko": 29,
	"./pic/teachers/katarzyna-stanko.png": 29,
	"./pic/teachers/katarzyna-stanko.webp": 347,
	"./pic/teachers/krzysztof-walaszek": 30,
	"./pic/teachers/krzysztof-walaszek.png": 30,
	"./pic/teachers/krzysztof-walaszek.webp": 348,
	"./pic/teachers/magdalena-kisly": 31,
	"./pic/teachers/magdalena-kisly.png": 31,
	"./pic/teachers/magdalena-kisly.webp": 349,
	"./pic/teachers/marin-iwai": 32,
	"./pic/teachers/marin-iwai.png": 32,
	"./pic/teachers/marin-iwai.webp": 350,
	"./pic/teachers/marta-klimiuk-nikkarinen": 33,
	"./pic/teachers/marta-klimiuk-nikkarinen.png": 33,
	"./pic/teachers/marta-klimiuk-nikkarinen.webp": 351,
	"./pic/teachers/marta-szulc": 34,
	"./pic/teachers/marta-szulc.png": 34,
	"./pic/teachers/marta-szulc.webp": 352,
	"./pic/teachers/miho-takahashi": 35,
	"./pic/teachers/miho-takahashi.png": 35,
	"./pic/teachers/miho-takahashi.webp": 353,
	"./pic/teachers/monika-zachaj": 36,
	"./pic/teachers/monika-zachaj.png": 36,
	"./pic/teachers/monika-zachaj.webp": 354,
	"./pic/teachers/owner": 294,
	"./pic/teachers/owner.png": 294,
	"./pic/teachers/ryotaro-sakamoto": 37,
	"./pic/teachers/ryotaro-sakamoto.png": 37,
	"./pic/teachers/ryotaro-sakamoto.webp": 355,
	"./pic/teachers/urszula-hellich": 38,
	"./pic/teachers/urszula-hellich.png": 38,
	"./pic/teachers/urszula-hellich.webp": 356,
	"./pic/teachers/weronika-smorag": 39,
	"./pic/teachers/weronika-smorag.png": 39,
	"./pic/teachers/weronika-smorag.webp": 357,
	"./pic/teachers/wiktoria-piontek": 40,
	"./pic/teachers/wiktoria-piontek.png": 40,
	"./pic/teachers/wiktoria-piontek.webp": 358,
	"./pic/team": 295,
	"./pic/team.jpg": 295,
	"./pic/testimonials/blank": 41,
	"./pic/testimonials/blank.jpg": 41,
	"./pic/testimonials/blank.webp": 359,
	"./pic/testimonials/gabrysia": 42,
	"./pic/testimonials/gabrysia.jpg": 42,
	"./pic/testimonials/gabrysia.webp": 360,
	"./pic/testimonials/klaudia": 43,
	"./pic/testimonials/klaudia.jpg": 43,
	"./pic/testimonials/klaudia.webp": 361,
	"./pic/testimonials/kuba": 44,
	"./pic/testimonials/kuba.jpg": 44,
	"./pic/testimonials/kuba.webp": 362,
	"./pic/testimonials/monika": 45,
	"./pic/testimonials/monika.jpg": 45,
	"./pic/testimonials/monika.webp": 363,
	"./pic/testimonials/naza": 46,
	"./pic/testimonials/naza.jpg": 46,
	"./pic/testimonials/naza.webp": 364,
	"./pic/testimonials/patti": 47,
	"./pic/testimonials/patti.jpg": 47,
	"./pic/testimonials/patti.webp": 365,
	"./pic/testimonials/wiktoria": 48,
	"./pic/testimonials/wiktoria.jpg": 48,
	"./pic/testimonials/wiktoria.webp": 366,
	"./pic/timeline": 296,
	"./pic/timeline.jpg": 296,
	"./pic/timeline/2011": 297,
	"./pic/timeline/2011.jpg": 297,
	"./pic/timeline/2013": 298,
	"./pic/timeline/2013.jpg": 298,
	"./pic/timeline/2014": 299,
	"./pic/timeline/2014.jpg": 299,
	"./pic/timeline/2016": 300,
	"./pic/timeline/2016.jpg": 300,
	"./pic/timeline/2017": 301,
	"./pic/timeline/2017.jpg": 301,
	"./pic/timeline/2018": 302,
	"./pic/timeline/2018.jpg": 302,
	"./pic/timeline/2019": 303,
	"./pic/timeline/2019.jpg": 303,
	"./pic/timeline/2020": 304,
	"./pic/timeline/2020.jpg": 304,
	"./pic/timeline/2021": 305,
	"./pic/timeline/2021.jpg": 305,
	"./pic/timeline/2022": 306,
	"./pic/timeline/2022.jpg": 306,
	"./pic/timeline/2023": 307,
	"./pic/timeline/2023.jpg": 307,
	"./pic/timeline/2024": 308,
	"./pic/timeline/2024.jpg": 308,
	"./pic/tree": 49,
	"./pic/tree.png": 49,
	"./pic/tree.webp": 367,
	"./pic/umbrella": 309,
	"./pic/umbrella.jpg": 309,
	"./pic/warsaw-card": 310,
	"./pic/warsaw-card.jpg": 310,
	"./pic/wave": 311,
	"./pic/wave.png": 311,
	"./pic/wsjj-team": 312,
	"./pic/wsjj-team-mobile": 313,
	"./pic/wsjj-team-mobile.webp": 313,
	"./pic/wsjj-team.webp": 312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 316;